import { LOGOUT } from "@/components/access/ducks/Actions"
import { RECEIVE_INTERNAL_ACCESS_REQUESTS } from "@/components/access/internal/ducks/Actions"

const defaultState = {
  accessRequests: [],
}

const internalAccessReducer = (oldState = defaultState, action) => {
  Object.freeze(oldState)
  switch (action.type) {
    case RECEIVE_INTERNAL_ACCESS_REQUESTS:
      return {
        ...oldState,
        accessRequests: action.accessRequests,
      }
    case LOGOUT:
      return defaultState

    default:
      return oldState
  }
}

export default internalAccessReducer
